export const PermissionGroup = {
  BUSINESS_UNITS: 'BUSINESS_UNITS',
  BUSINESS_STOCKS: 'BUSINESS_STOCKS',
  BUSINESS_SERVICES: 'BUSINESS_SERVICES',
  ROLES: 'ROLES',
  ACCESSES: 'ACCESSES',
  USERS: 'USERS',
  CLIENTS: 'CLIENTS',
  PRODUCTS: 'PRODUCTS',
  PRODUCT_CATEGORIES: 'PRODUCT_CATEGORIES',
  TRANSACTIONS: 'TRANSACTIONS',
  REPORTS: 'REPORTS',
  STATISTICS: 'STATISTICS',
  ACCESS_GROUPS: 'ACCESS_GROUPS',
  ROLE_ACCESSES: 'ROLE_ACCESSES',
  PRODUCT_BRANDS: 'PRODUCT_BRANDS',
  COUNTRIES: 'COUNTRIES',
  MEASURE_UNITS: 'MEASURE_UNITS',
  PRODUCT_TYPES: 'PRODUCT_TYPES',
  PROFIT: 'PROFIT',
  SUPPLIERS: 'SUPPLIERS',
  TRANSFERS: 'TRANSFERS',
  SETTINGS: 'SETTINGS',
  STATUSES: 'STATUSES',
  ALL_BU_TRANSACTIONS: 'ALL_BU_TRANSACTIONS',
  PAYROLLS: 'PAYROLLS',
  EXPENSES: 'EXPENSES',
  INSTALLMENTS: 'INSTALLMENTS',
  INSTALLMENT_CARDS: 'INSTALLMENT_CARDS',
  INSTALLMENT_LINES: 'INSTALLMENT_LINES',
  INSTALLMENT_CASHBACK: 'INSTALLMENT_CASHBACK',
  INVENTORY_ADJUSTMENTS: 'INVENTORY_ADJUSTMENTS',
  SMS_MESSAGES: 'SMS_MESSAGES',
  SMS_TEMPLATES: 'SMS_TEMPLATES',
  SMS_CONTACT_GROUPS: 'SMS_CONTACT_GROUPS',
  SMS_PLAN: 'SMS_PLAN',
  CLIENT_ISSUES: 'CLIENT_ISSUES',
  CAMPAIGNS: 'CAMPAIGNS',
  CLIENT_INTERACTIONS: 'CLIENT_INTERACTIONS',
  CRM_STATISTICS: 'CRM_STATISTICS',
  EXCHANGE_RATES: 'EXCHANGE_RATES',
  CLIENT_STATUSES: 'CLIENT_STATUSES',
  CLIENT_LEAD_QUALITY: 'CLIENT_LEAD_QUALITY',
  ORDER_REQUESTS: 'ORDER_REQUESTS',
  ONLINE_SHOP: 'ONLINE_SHOP',
  BANNERS: 'BANNERS',
  CASHIER_SESSION: 'CASHIER_SESSION',
  CLIENT_BLACKLIST: 'CLIENT_BLACKLIST',
};
